module.exports = __webpack_public_path__ + "static/media/results-page-insights-icon.e0baa540.svg";